import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Card, CardContent } from '../ui/card';
import { Loader2 } from 'lucide-react';
import { QuestionnaireQuestion } from '../../services/sowConversationService';

interface TextQuestionProps {
  question: QuestionnaireQuestion;
  onContinue: (response: string) => Promise<void>;
  isSubmitting: boolean;
}

export const TextQuestion: React.FC<TextQuestionProps> = ({
  question,
  onContinue,
  isSubmitting
}) => {
  const [userInput, setUserInput] = useState('');

  const handleContinue = async () => {
    if (userInput.trim()) {
      await onContinue(userInput.trim());
      setUserInput('');
    }
  };

  return (
    <Card className="max-w-4xl mx-auto">
      <CardContent className="p-8 relative">

        {/* Text Input for open-ended questions */}
        <div className="space-y-4 mb-8">
          <Input
            placeholder="Type your response..."
            value={userInput}
            onChange={(e) => setUserInput(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && !isSubmitting && handleContinue()}
            className="w-full p-4 text-lg border-2 rounded-lg focus:border-blue-500"
            disabled={isSubmitting}
          />
        </div>

        {/* Action Buttons */}
        <div className="flex justify-center items-center gap-4 pt-6">
          <Button 
            onClick={handleContinue}
            disabled={!userInput.trim() || isSubmitting}
            size="lg"
            className="px-12 py-3 text-lg font-semibold"
          >
            {isSubmitting ? (
              <>
                <Loader2 className="w-5 h-5 mr-2 animate-spin" />
                Processing...
              </>
            ) : (
              'Continue'
            )}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};